import { withMonitoring } from '../monitoring/withMonitoring'
import { httpClient } from './httpClient'

export const suggestDomains = async (params: { query: string; limit: number }) => {
  const request = () => httpClient.get(`/suggestDomain?query=${encodeURIComponent(params.query)}&limit=${1}`)
  return withMonitoring(request, 'suggestDomains')
}
